export default "__VITE_ASSET__dddf71fe__"